// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rail-module .new-popular-pages-experiment h2{background-image:none;margin:unset;padding:unset}.rail-module .new-popular-pages-experiment{--widget-frame-background-color: var(--right-rail-background-color)}.rail-module .new-popular-pages-experiment .widget-frame{background-color:unset !important;max-width:300px !important;padding-left:0;padding-right:0}.Tyt1OeLqHQCXByQxarCH{display:flex;flex-direction:column;gap:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popularPagesContentWrapper": `Tyt1OeLqHQCXByQxarCH`
};
export default ___CSS_LOADER_EXPORT___;
